import { generateClient } from "aws-amplify/api";
import { FormTemplateForResolver } from "db/definitions";
import { recordSentry } from "utils/recordSentry";
import { createFormTemplate } from "../graphql/mutations";

export default async function _createFormTemplate(
	formTemplate: Pick<FormTemplateForResolver, "id" | "template" | "group"> & Partial<FormTemplateForResolver>,
): Promise<void> {
	try {
		const client = generateClient({ authMode: "userPool" });
		await client.graphql({
			query: createFormTemplate,
			variables: {
				input: formTemplate,
			},
			authMode: "userPool",
		});
	} catch (error) {
		recordSentry({ error, msg: "Caught an error updating formTemplate" });
	}
}
